import React, { ReactNode } from "react";
import { AlertIcon } from "../assets/icons/icon-alert";
import css from "./CoreTab.module.css";

interface CoreTabProps {

    // injected from parent 
    isActive?: boolean

    //Content
    children?: ReactNode;

    title: string;

    index?: number;

    onClick?: (args: any) => void;

    hasError?: boolean
    hasWarning?: boolean

}

const activeClass = `border-t-green-500 border-b-white border-y-2 bg-white text-green-700 ${css.active} border-x-2`;
const noActiveClass = 'border-y-2 border-b-gray-200 border-t-transparent bg-gray-100 text-gray-500 border-x-2 border-x-transparent';
const commonClass = "";

export const CoreTab = ({ isActive, index, title, children, onClick, hasError = false, hasWarning = false }: CoreTabProps) => {

    return (<li
        onClick={onClick}
        style={{ cursor: "pointer" }}
        className={`tab mx-2 rounded-t hover:bg-gray-50 px-3 py-2 text-sm font-medium flex ${isActive ? activeClass : noActiveClass}`} >
        {title}
        {(hasError || hasWarning) && <span className="pl-2"><AlertIcon className={`${hasError ? "stroke-red-500": "stroke-amber-500"} `} size={18} /></span>}

    </li >
    )


}